import { GESTION_OPERATIVA_SELECT_STOCK } from './constants'
import { BFFAgent } from 'BFFAgent'

export function selectStock(stock) {
  return async (dispatch, getState) => {
    const { gestionOperativa } = getState()
    const selectedStock = gestionOperativa?.sale?.auto?.Stocks?.find(s => s.id === stock.stock_id)
    const carlot = selectedStock?.owner_id ? await BFFAgent.Datamasters.getCarlot(selectedStock.owner_id) : undefined 

    dispatch({
      type: GESTION_OPERATIVA_SELECT_STOCK,
      data: {
        ...gestionOperativa.sale,
        ...stock,
        integration_car_lot_name: carlot?.name || gestionOperativa?.sale.car_lot_name,
        integration_branch_office_name: stock.stock_sucursal,
      }
    })
  }
}

export function reducer(state, action) {
  if (action.type === GESTION_OPERATIVA_SELECT_STOCK) {
    return {
      ...state,
      sale: {
        ...action.data
      },
      isModified: true,
      savedSale: false
    }
  }
  else {
    return state
  }
}
